/* bvm-finanziamenti.js — FINANZIAMENTI F2 (23/10/2026, sessione C): il modulo «Paga a rate» (snippets/bvm-finanziamenti.liquid).
   · Lo aprono i pulsanti data-bvm-fin-apri (pagina carrello e mini carrello): il clic si raccoglie sul documento, perché il tema
     ridisegna il mini carrello. All'apertura si rilegge /cart.js: il totale serve per la quota indicativa e la riga dell'acconto.
   · Testi, durate, canali, tetto e soglia dalla config (JSON del metafield shop.metafields.finanziamenti.modulo).
   · Controlli come controllaModulo del motore (src/utils/finanziamenti.js); l'ultima parola è della function, che rifà tutto.
   · Partita IVA: messaggio e contatti, la richiesta non parte. Invio: solo variant_id e quantità, il totale visto come riferimento. */
(function () {
  var dlg = document.getElementById('bvm-fin');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var cfg = {};
  try { cfg = JSON.parse(dlg.querySelector('[data-bvm-fin-config]').textContent || '{}'); } catch (e) { return; }
  var T = cfg.testi || {};
  var form = dlg.querySelector('[data-bvm-fin-modulo]'), resto = dlg.querySelector('[data-bvm-fin-resto]');
  var piva = dlg.querySelector('[data-bvm-fin-piva]'), errBox = dlg.querySelector('[data-bvm-fin-errori]');
  var conferma = dlg.querySelector('[data-bvm-fin-conferma]'), invia = dlg.querySelector('[data-bvm-fin-invia]');
  var carrello = null, chiAprì = null;

  /* euro come euroTesto del motore: punto delle migliaia, centesimi solo se ci sono */
  function euroTesto(x) {
    var v = Math.round((Number(x) + Number.EPSILON) * 100) / 100, p = Math.abs(v).toFixed(2).split('.');
    return (v < 0 ? '−' : '') + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (p[1] === '00' ? '' : ',' + p[1]);
  }
  function testo(el, t) { if (el) el.textContent = t || ''; }
  Array.prototype.forEach.call(dlg.querySelectorAll('[data-bvm-fin-testo]'), function (el) { testo(el, T[el.getAttribute('data-bvm-fin-testo')]); });

  /* ── scelte dalla config ── */
  function scelta(nome, valore, etichetta, dettaglio) {
    var l = document.createElement('label'); l.className = 'bvm-fin__scelta';
    var i = document.createElement('input'); i.type = 'radio'; i.name = nome; i.value = valore; i.required = true;
    var s = document.createElement('span'); s.className = 'bvm-fin__scelta-testo';
    var b = document.createElement('span'); b.className = 'bvm-fin__scelta-nome'; b.textContent = etichetta; s.appendChild(b);
    if (dettaglio) { var d = document.createElement('span'); d.className = 'bvm-fin__scelta-dettaglio'; d.textContent = dettaglio; s.appendChild(d); }
    l.appendChild(i); l.appendChild(s); return l;
  }
  function quota(totale, durata) {
    if (!cfg.mostra_quota_indicativa || !(totale > 0) || durata === 'consiglio') return '';
    if (durata === '48-60') return 'circa ' + euroTesto(totale / 60) + '–' + euroTesto(totale / 48) + ' € al mese · ' + (T.quota || '');
    var n = Number(durata); return n > 0 ? 'circa ' + euroTesto(totale / n) + ' € al mese · ' + (T.quota || '') : '';
  }
  function costruisci() {
    var tot = carrello ? carrello.totale : 0;
    var box = dlg.querySelector('[data-bvm-fin-durate]'), prima = (form.querySelector('[name=durata_preferita]:checked') || {}).value;
    box.textContent = '';
    (cfg.durate || []).forEach(function (d) { box.appendChild(scelta('durata_preferita', d.valore, d.etichetta, quota(tot, d.valore))); });
    if (prima) { var p = box.querySelector('[value="' + prima + '"]'); if (p) p.checked = true; }
    var cb = dlg.querySelector('[data-bvm-fin-canali]'), primoC = (form.querySelector('[name=canale_preferito]:checked') || {}).value;
    cb.textContent = '';
    (cfg.canali || []).forEach(function (c) {
      var t = T[c.valore];
      if (c.valore === 'online' && !t) return;                       /* senza tabelle online attive niente opzione online */
      var dett = c.valore === 'consiglio' ? '' : t;
      var el = scelta('canale_preferito', c.valore, c.etichetta, dett);
      if (c.valore === 'online' && T.riga_acconto && cfg.tetto_online != null && tot > Number(cfg.tetto_online)) {
        var r = document.createElement('span'); r.className = 'bvm-fin__acconto'; r.setAttribute('data-bvm-fin-acconto', '');
        r.textContent = String(T.riga_acconto).split('{{totale}}').join(euroTesto(tot)).split('{{resto}}').join(euroTesto(tot - Number(cfg.tetto_online)));
        el.querySelector('.bvm-fin__scelta-testo').appendChild(r);
      }
      cb.appendChild(el);
    });
    if (primoC) { var q = cb.querySelector('[value="' + primoC + '"]'); if (q) q.checked = true; }
  }

  /* ── anticipo (C2, 23/10/2026): solo con cfg.chiedi_anticipo === true. Facoltativo, in euro, mai bloccante per il minimo. Il testo è
     testi.anticipo: le frasi con {{resto}} compaiono solo col canale online e il carrello oltre il tetto (resto = totale − tetto_online),
     con la cifra; senza il segnaposto, col canale online oltre il tetto si aggiunge una riga col minimo indicativo. ── */
  var anticipoBox = dlg.querySelector('[data-bvm-fin-anticipo]'), anticipoTesto = dlg.querySelector('[data-bvm-fin-anticipo-testo]');
  var chiediAnticipo = cfg.chiedi_anticipo === true;
  /* «1.500», «1500,50», «1.500,5 €», «200» → numero; '' → null; altro → NaN */
  function anticipoNumero() {
    var s = val('anticipo').replace(/[€\s]/g, '');
    if (!s) return null;
    if (s.indexOf(',') >= 0) s = s.replace(/\./g, '').replace(',', '.');
    else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, '');
    if (!/^\d+(\.\d{1,2})?$/.test(s)) return NaN;
    return Math.round(Number(s) * 100) / 100;
  }
  function restoOnline() {
    var tot = carrello ? carrello.totale : 0, tetto = cfg.tetto_online;
    if ((form.querySelector('[name=canale_preferito]:checked') || {}).value !== 'online' || tetto == null || !(tot > Number(tetto))) return null;
    return tot - Number(tetto);
  }
  function aggiornaAnticipo() {
    if (!anticipoBox) return;
    anticipoBox.hidden = !chiediAnticipo;
    if (!chiediAnticipo) return;
    var resto = restoOnline(), base = String(T.anticipo || '');
    var frasi = (base.match(/[^.!?]+[.!?]*/g) || []).map(function (f) { return f.trim(); }).filter(function (f) { return f; }).filter(function (f) { return f.indexOf('{{resto}}') < 0 || resto != null; })
      .map(function (f) { return f.split('{{resto}}').join(euroTesto(resto)); });
    if (resto != null && base.indexOf('{{resto}}') < 0) frasi.push('Online: indicativamente almeno ' + euroTesto(resto) + ' €.');
    anticipoTesto.textContent = frasi.join(' ');
    anticipoTesto.hidden = !anticipoTesto.textContent;
  }

  /* ── partita IVA: messaggio, niente invio ── */
  function aggiornaTipo() {
    var pi = (form.querySelector('[name=tipo_cliente]:checked') || {}).value === 'partita_iva';
    piva.hidden = !pi; resto.hidden = pi;
  }
  form.addEventListener('change', function (e) { if (e.target.name === 'tipo_cliente') aggiornaTipo(); if (e.target.name === 'canale_preferito') aggiornaAnticipo(); if (e.target.getAttribute('aria-invalid')) e.target.removeAttribute('aria-invalid'); });

  /* ── controlli (come controllaModulo) ── */
  function val(n) { var el = form.elements[n]; return el ? String(el.value || '').trim() : ''; }
  function controlla() {
    var e = [], campi = [];
    function manca(n, l) { if (!val(n)) { e.push('Manca ' + l + '.'); campi.push(n); } }
    manca('nome', 'il nome'); manca('cognome', 'il cognome'); manca('email', "l'email"); manca('telefono', 'il telefono'); manca('citta', 'la città');
    if (val('email') && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('email'))) { e.push("L'email non è valida."); campi.push('email'); }
    if (val('telefono') && val('telefono').replace(/\D/g, '').length < 6) { e.push('Il telefono non è valido.'); campi.push('telefono'); }
    if (!/^[A-Z]{2}$/.test(val('provincia'))) { e.push('Scegli la provincia.'); campi.push('provincia'); }      /* tendina: il valore è la sigla */
    if (!form.querySelector('[name=tipo_cliente]:checked')) { e.push('Scegli privato o partita IVA.'); campi.push('tipo_cliente'); }
    if (!form.querySelector('[name=durata_preferita]:checked')) { e.push('Scegli la durata.'); campi.push('durata_preferita'); }
    if (!form.querySelector('[name=canale_preferito]:checked')) { e.push('Scegli dove preferisci.'); campi.push('canale_preferito'); }
    if (chiediAnticipo && isNaN(anticipoNumero())) { e.push("L'anticipo va scritto in euro, per esempio 500 o 1.250,50 (oppure lascialo vuoto)."); campi.push('anticipo'); }
    if (!form.elements.consenso_privacy.checked) { e.push('Serve il consenso al trattamento dei dati.'); campi.push('consenso_privacy'); }
    return { errori: e, campi: campi };
  }
  function mostraErrori(lista, campi) {
    Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid]'), function (x) { x.removeAttribute('aria-invalid'); });
    (campi || []).forEach(function (n) { var el = form.elements[n]; if (el && el.setAttribute) el.setAttribute('aria-invalid', 'true'); else if (el && el.length) Array.prototype.forEach.call(el, function (x) { x.setAttribute('aria-invalid', 'true'); }); });
    errBox.textContent = '';
    if (!lista.length) { errBox.hidden = true; return; }
    var ul = document.createElement('ul'); lista.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
    errBox.appendChild(ul); errBox.hidden = false;
    var primo = campi && campi.length ? form.elements[campi[0]] : null; if (primo && primo.focus) primo.focus(); else if (primo && primo[0]) primo[0].focus();
  }

  /* ── carrello ── */
  function leggiCarrello() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrello = { totale: (c.total_price || 0) / 100, righe: (c.items || []).map(function (i) { return { variant_id: String(i.variant_id), quantita: i.quantity }; }) }; return carrello; });
  }

  /* ── apri, chiudi ── */
  function apri(da) {
    chiAprì = da || null;

    leggiCarrello().catch(function () { carrello = carrello || { totale: 0, righe: [] }; }).then(function () {
      costruisci(); aggiornaTipo(); aggiornaAnticipo();
      form.hidden = false; conferma.hidden = true; errBox.hidden = true;
      if (!dlg.open) dlg.showModal();
      document.documentElement.classList.add('bvm-fin-aperto');
      var primo = Array.prototype.find.call(form.querySelectorAll('input:not([type=hidden]):not([tabindex="-1"])'), function (i) { return i.type !== 'radio' && i.type !== 'checkbox' && !i.value; });
      (primo || form.querySelector('[name=tipo_cliente]')).focus();
    });
  }
  function chiudi() { if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', function () { document.documentElement.classList.remove('bvm-fin-aperto'); if (chiAprì && document.contains(chiAprì)) chiAprì.focus(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) chiudi(); if (e.target.closest('[data-bvm-fin-chiudi]')) chiudi(); });
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-bvm-fin-apri]'); if (b) { e.preventDefault(); apri(b); } });

  /* ── invio ── */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if ((form.querySelector('[name=tipo_cliente]:checked') || {}).value === 'partita_iva') { aggiornaTipo(); return; }
    var c = controlla(); mostraErrori(c.errori, c.campi); if (c.errori.length) return;
    invia.disabled = true; invia.textContent = 'Invio in corso…';
    leggiCarrello().then(function (car) {
      var dati = {
        nome: val('nome'), cognome: val('cognome'), email: val('email'), telefono: val('telefono'), citta: val('citta'), provincia: val('provincia'),
        tipo_cliente: 'privato', durata_preferita: form.querySelector('[name=durata_preferita]:checked').value,
        canale_preferito: form.querySelector('[name=canale_preferito]:checked').value, note: String(form.elements.note.value || '').trim(),
        consenso_privacy: true, shopify_customer_id: val('shopify_customer_id') || null,
        righe: car.righe, totale_dichiarato: car.totale, mercato: dlg.getAttribute('data-mercato'), lingua: dlg.getAttribute('data-lingua'),
        prova: dlg.getAttribute('data-prova') === 'true', sito_web: val('sito_web'),
      };
      var ap = chiediAnticipo ? anticipoNumero() : null; if (ap != null && !isNaN(ap)) dati.anticipo_proposto = ap;   /* solo se compilato */
      return fetch(dlg.getAttribute('data-url'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dati) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { stato: r.status, j: j }; }); });
    }).then(function (x) {
      var j = x.j || {};
      if (j.ok) { form.hidden = true; conferma.hidden = false; conferma.focus(); return; }
      if (j.blocco === 'partita_iva') { form.querySelector('[name=tipo_cliente][value=partita_iva]').checked = true; aggiornaTipo(); return; }
      if (j.blocco === 'soglia') { var sg = j.soglia != null ? j.soglia : cfg.soglia_carrello; /* la soglia della function (config), altrimenti quella del metafield */ mostraErrori(['Il carrello non supera più ' + euroTesto(sg) + ' €: il pagamento a rate si può richiedere per importi superiori.'], []); return; }
      if (x.stato === 429) { mostraErrori(['Hai già inviato diverse richieste: riprova più tardi o scrivici a servizioclienti@videosell.it.'], []); return; }
      if (j.errori && j.errori.length) { mostraErrori(j.errori.map(function (t) { return t.charAt(0).toUpperCase() + t.slice(1) + '.'; }), []); return; }
      mostraErrori(['Invio non riuscito. Riprova fra poco, oppure scrivici a servizioclienti@videosell.it.'], []);
    }).catch(function () {
      mostraErrori(['Invio non riuscito. Controlla la connessione e riprova, oppure scrivici a servizioclienti@videosell.it.'], []);
    }).then(function () { invia.disabled = false; invia.textContent = 'Invia la richiesta'; });
  });
})();
